import { helpers } from '@vuelidate/validators';

const voucherCode = helpers.regex(/^[a-zA-Z0-9]{3}-?[a-zA-Z0-9]{3}-?[a-zA-Z0-9]{3}$/);

export default voucherCode;
